module.exports = __webpack_public_path__ + "img/schlauch_px.8d5fa10f.png";